import gql from 'graphql-tag';

export const JOBS_CREATIVES_CREATE_JOB = gql`
  query JobsCreativesCreateJob($id: ID!) {
    jobsCreativesCreateJob(id: $id) {
      id
      status
      error
      carouselItems {
        callToAction
        sourceType
        error
        article {
          id
          campaign {
            id
            name
            flipperFeatures {
              name
              enabled
            }
          }
          title
          url
        }
        creative {
          id
          postId
        }
        creativeTemplate {
          id
        }
        facebookLeadgenForm {
          id
        }
      }
      imageOrVideoItems {
        imageUrl
        postText
        headline
        description
        callToAction
        sourceType
        error
        article {
          id
          campaign {
            id
            name
            flipperFeatures {
              name
              enabled
            }
          }
          title
          url
        }
        creative {
          id
          postId
        }
        creativeTemplate {
          id
        }
        facebookLeadgenForm {
          id
        }
      }
    }
  }
`;
